// extracted by mini-css-extract-plugin
module.exports = {"modalText":"styles_modalText__3sUde","modalActions":"styles_modalActions__3dTJB"};